import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import axios from "axios";
import { useCallback } from "react";

export function useApiClient() {
  const { instance, accounts } = useMsal();
  
  const callApi = useCallback(async (
    url: string,
    options?: {
      method?: "GET" | "POST" | "PUT" | "DELETE";
      data?: any;
      signal?: AbortSignal;
    }
  ) => {
    const response = await instance.acquireTokenSilent({
      ...loginRequest,
      account: accounts[0],
    });
    const token = response.accessToken;
    const method = options?.method || "GET";
    return axios({
      url,
      method,
      data: options?.data,
      signal: options?.signal,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  }, [instance, accounts]);

  return { callApi };
}